// extracted by mini-css-extract-plugin
export var filterIncDec = "_bg-0";
export var leftBorder = "_bg-1";
export var rightBorder = "_bg-2";
export var stringInput = "_bg-3";